module.exports = __webpack_public_path__ + "static/media/5.2 Eisvogel OfR klein.09b1b721.jpg";